import { getApiUrl } from '../utils/apiUrl';

const API_BASE = getApiUrl();

export const fetchQuickLinks = async (token) => {
  const res = await fetch(`${API_BASE}/quick-links`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunne ikke hente lenker');
  return res.json();
};

export const createQuickLink = async (token, data) => {
  const res = await fetch(`${API_BASE}/quick-links`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Kunne ikke opprette lenke');
  }
  return res.json();
};

export const updateQuickLink = async (token, id, data) => {
  const res = await fetch(`${API_BASE}/quick-links/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Kunne ikke oppdatere lenke');
  }
  return res.json();
};

export const deleteQuickLink = async (token, id) => {
  const res = await fetch(`${API_BASE}/quick-links/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Kunne ikke slette lenke');
  }
  return res.json();
};
